import React, { useContext, useEffect } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';

import { GlobalContext } from '../../reducers/global';
import langs from '../../translations/langs';
import Input from '../Input';
import PopUp from '../PopUp';
import isDate from 'date-fns/isDate';

const Measurement = ({ measurementSystem, dataSet, index, state, setState, register, getValues, errors }) => {
  const {
    state: {
      options: { language },
    },
  } = useContext(GlobalContext);
  const { height, heightFt, heightIn, weight, weightSt, weightLb, date } = state[index];
  const { step3 } = langs[language];

  const setter = (name, val) => {
    const current = [...state];
    // Ensure value is updated to avoid infinite re-render
    if (current[index][name] !== val) {
      if (measurementSystem === 'imperial') {
        current[index][name] = val;
        const inches = current[index].heightIn ? Number(current[index].heightIn) : 0;
        const pounds = current[index].weightLb ? Number(current[index].weightLb) : 0;
        current[index].height = (current[index].heightFt * 12 + inches) * 2.54;
        current[index].weight =
          dataSet === 'Canada' || dataSet === 'United States'
            ? (current[index].weightSt * 16) / 35.27
            : (current[index].weightSt * 14 + pounds) / 2.205;
        setState(current);
      } else {
        current[index][name] = val;
        setState(current);
      }
    }
  };

  useEffect(() => {
    const nowDate = new Date().toISOString().slice(0, 10);
    const dateText = (date && isDate(date)) ? date.toISOString().slice(0,10) : nowDate;
    // console.log('useEffect date', dateText)
    setter('date', dateText);
  }, []);

  return (
    <>
      {/* <Input
        className="full-width"
        label={step3.measurementsLabel}
        register={register({ required: true })}
        required
        name={`${index}measurementDate`}
        type="date"
        placeholder={step3.measurementsPlaceholder}
        errors={errors}
        value={date}
        setValue={(val) => {
          setter('date', val);
        }}
      /> */}
      {/* <LocalizationProvider dateAdapter={AdapterDateFns} >
        <div className={`input-container full-width`}>
          <label htmlFor={'birthDateDD'}>
            <b style={{ fontWeight: 'normal' }}>{step3.measurementsLabel}<sup style={{ color: 'crimson' }}>*</sup></b>
          </label>  
          <DatePicker
            name={`${index}measurementDate`}
            value={date}
            rules={{ required: true, validate: (value) => !isNaN(Date.parse(value)) }}
            onChange={(newValue) => {
              const dateText = (newValue) ? newValue.toJSON().slice(0,10) : '';
              setter('date', dateText);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </div>
      </LocalizationProvider> */}
      {/* <PopUp linkText={step3.heightLink} modalText={step3.heightModal} /> */}
      {measurementSystem === 'imperial' ? (
        <>
          {/* IMPERIAL */}
          <div className="imperial-height">
            <Input
              label={step3.heightLabelImperial}
              register={register({ required: true, min: 1, max: 20 })}
              required
              step="1"
              min="1"
              name={`${index}heightFt`}
              // type="number"
              placeholder={step3.heightPlaceholderFt}
              errors={errors}
              value={heightFt}
              setValue={(val) => {
                setter('heightFt', val);
              }}
            />
            <Input
              label="&nbsp;"
              register={register({ min: 0, max: 11 })}
              name={`${index}heightIn`}
              // type="number"
              step="1"
              min="0"
              placeholder={step3.heightPlaceholderIn}
              errors={errors}
              value={heightIn}
              setValue={(val) => {
                setter('heightIn', val);
              }}
            />
          </div>
          <div className="imperial-weight">
            {dataSet === 'Canada' || dataSet === 'United States' ? (
              <>
                {/* POUNDS & OUNCES */}
                <Input
                  label={step3.weightLabel}
                  register={register({
                    validate: {
                      /*
                       * WEIGHT IN POUNDS VALIDATOR:
                       * Custom USA-style weight validation - ie. if all in Ounces, with no Stones.
                       * 700 Pound/11200oz max weight, sixteen Ounces in a Pound.
                       * If this field is zero, then the weight in Ounces has to be more than zero.
                       * If the weight in Ounces is more than fifteen, then this field has to be zero.
                       */
                      moreThanZero: (value) => {
                        const weightInOunces = parseInt(getValues(`${index}weightLb`), 10);
                        const val = parseInt(value, 10);
                        return (val === 0 && weightInOunces > 0) || val > 0;
                      },
                      lessThanMaximum: (value) => {
                        const weightInOunces = parseInt(getValues(`${index}weightLb`), 10);
                        const val = parseInt(value, 10);
                        if (weightInOunces > 15 && val !== 0) {
                          return false;
                        }
                        return val < 700;
                      },
                    },
                    required: true,
                  })}
                  name={`${index}weightSt`}
                  // type="number"
                  step="1"
                  min="0"
                  required
                  placeholder={step3.weightPlaceholderLb}
                  errors={errors}
                  value={weightSt}
                  setValue={(val) => {
                    setter('weightSt', val);
                  }}
                />
              </>
            ) : (
              <>
                {/* STONES & POUNDS */}
                <Input
                  label={step3.weightLabel}
                  register={register({
                    validate: {
                      /*
                       * WEIGHT IN STONES VALIDATOR:
                       * Custom USA-style weight validation - ie. if all in Pounds, with no Stones.
                       * 50 Stone/700lb max weight, fourteen Pounds in a Stone.
                       * If this field is zero, then the weight in Pounds has to be more than zero.
                       * If the weight in Pounds is more than thirteen, then this field has to be zero.
                       */
                      moreThanZero: (value) => {
                        const weightInPounds = parseInt(getValues(`${index}weightLb`), 10);
                        const val = parseInt(value, 10);
                        return (val === 0 && weightInPounds > 0) || val > 0;
                      },
                      lessThanMaximum: (value) => {
                        const weightInPounds = parseInt(getValues(`${index}weightLb`), 10);
                        const val = parseInt(value, 10);
                        if (weightInPounds > 13 && val !== 0) {
                          return false;
                        }
                        return val < 50;
                      },
                    },
                    required: true,
                  })}
                  name={`${index}weightSt`}
                  // type="number"
                  step="1"
                  min="0"
                  required
                  placeholder={step3.weightPlaceholderSt}
                  errors={errors}
                  value={weightSt}
                  setValue={(val) => {
                    setter('weightSt', val);
                  }}
                />
                <Input
                  label="&nbsp;"
                  register={register({
                    validate: {
                      /*
                       * WEIGHT IN POUNDS VALIDATOR:
                       * Custom USA-style weight validation - ie. if all in Pounds, with no Stones.
                       * 50 Stone/700lb max weight, fourteen Pounds in a Stone.
                       * If this field is zero, then then the weight in Stone has to be more than zero.
                       * If the weight in Stone is not zero, then this field has to be more than thirteen.
                       */
                      moreThanZero: (value) => {
                        const weightInStones = parseInt(getValues(`${index}weightSt`), 10);
                        const val = parseInt(value, 10);
                        return (val === 0 && weightInStones > 0) || val > 0;
                      },
                      lessThanMaximum: (value) => {
                        const weightInStones = parseInt(getValues(`${index}weightSt`), 10);
                        const val = parseInt(value, 10);
                        return (val > 13 && weightInStones !== 0) || val < 700;
                      },
                    },
                    required: true,
                  })}
                  name={`${index}weightLb`}
                  // type="number"
                  step="1"
                  min="0"
                  placeholder={step3.weightPlaceholderLb}
                  errors={errors}
                  value={weightLb}
                  setValue={(val) => {
                    setter('weightLb', val);
                  }}
                />
              </>
            )}
          </div>
        </>
      ) : (
        <div className="column-2 no-margin">
          {/* METRIC */}
          <Input
            label={step3.heightLabel}
            register={register({ required: true, min: 20, max: 300})}
            required
            name={`${index}height`}
            // type="number"
            placeholder={step3.heightPlaceholderCm}
            errors={errors}
            step="1"
            value={height}
            setValue={(val) => {
              setter('height', val);
            }}
            errorMessage={errors[`${index}height`] ? step3.errorHeight : ''}
          />

          <Input
            label={step3.weightLabel}
            register={register({ required: true, min: 1, max: 100})}
            required
            name="weight"
            // type="number"
            step="1"
            placeholder={step3.weightPlaceholderKg}
            errors={errors}
            value={weight}
            setValue={(val) => {
              setter('weight', val);
            }}
            errorMessage={errors['weight'] ? step3.errorWeight : ''}
          />
        </div>
      )}
    </>
  );
};

export default Measurement;
